import React from 'react';
import moment from 'moment';
import {Decimal} from 'decimal.js';
import {labels, currentResource} from '../../../../../../../util/utils';
import {defaultDateFormat, ExecutionType} from '../../../../../../../util/uiconstants';
import Utility from '../../../../../../../util/utilityfunctions';

import RiskPills from '../../../../../../Common/RiskPills/index';

export const convertToDecimal = (value, floor = false, round = false, roundVal = 1) => {
	if (floor) {
		return Decimal(value)
			.floor()
			.toString();
	}
	if (round) {
		return Decimal(value)
			.round(roundVal)
			.toString();
	} else {
		return Decimal(value).toString();
	}
};

export const displayTooltip = (value, onMultipleClick) => {
	if (value === 'Analytics') {
		return (
			<span className={`tooltiplabel ${value === 'Analytics' && 'showTxt'}`} onClick={onMultipleClick}>
				{labels.multiple}
			</span>
		);
	} else {
		return <span className="noDataDash">{'-'}</span>;
	}
};

export const displayDate = (date, userPreferences) => {
	if (date) {
		const dateFormatter = userPreferences.dateFormat ? userPreferences.dateFormat : defaultDateFormat;
		const userFormattedDate = moment(date).format(Utility.convertUserPreferencesDateFormatToMoment(dateFormatter));

		return userFormattedDate;
	} else {
		return '-';
	}
};

export const displayRiskPill = (assertions, showRiskTooltip = true) => {
	let riskList = [];
	assertions?.map((assertion) => {
		assertion.risks?.map((risk) => {
			riskList.push({
				id: risk.id,
				riskName: risk.riskName,
				riskTypeId: risk.riskTypeId
			});
		});
	});

	//filter out duplicate risks
	const risks = riskList.filter(
		(value, index, self) => self.findIndex((risk) => risk && risk.id === value.id) === index
	);

	if (risks.length > 0) {
		return (
			<RiskPills
				closeTooltipOnOutsideClick
				risks={risks}
				className={'riskPillsContainer'}
				showTooltip={showRiskTooltip}
			/>
		);
	} else return <span className="noDataDash">{'-'}</span>;
};

export const renderExecutionType = (executionTypeId) => {
	if (executionTypeId && executionTypeId !== ExecutionType.ExecutedInEngagement) {
		return (
			<section
				className="executionTypeLabel"
				title={currentResource.executionType.find((et) => et.id === executionTypeId)?.toolTip}
			>
				<span className="executionTypeText">
					{currentResource.executionType.find((et) => et.id === executionTypeId)?.label}
				</span>
			</section>
		);
	}
};

export const getAccountDesignation = (value) => {
	if (value) {
		return currentResource.AccountType.find((account) => account.id === value).accounttypename;
	} else return <span className="noDataDash">{'-'}</span>;
};
